import { E32 } from "../theme/endesga32";
import { pixelTheme } from "../theme/pixel";

// How long the "+N XP" label drifts up + fades for. The page
// schedules a cleanup at this delay to remove labels whose `bornAt`
// is older.
export const FLOAT_DURATION_MS = 1100;

export interface ForageFloatingXp {
  id: string;
  x: number;
  y: number;
  amount: number;
  bornAt: number;
}

interface Props {
  float: ForageFloatingXp;
}

// "+N XP" label that floats up + fades over `FLOAT_DURATION_MS`
// after a successful harvest click. Pure presentation — the page
// owns the lifetime and removes the label from its list once the
// animation has played.
export function ForageFloatingXpLabel({ float }: Props) {
  return (
    <div
      style={{
        position: "absolute",
        left: float.x,
        top: float.y,
        pointerEvents: "none",
        fontFamily: pixelTheme.fontDisplay,
        fontSize: 12,
        letterSpacing: "0.08em",
        color: E32.ruby,
        textShadow:
          `1px 1px 0 ${E32.parchment}, -1px -1px 0 ${E32.parchment}, ` +
          `1px -1px 0 ${E32.parchment}, -1px 1px 0 ${E32.parchment}`,
        zIndex: 250,
        animation: `forage-float-xp ${FLOAT_DURATION_MS}ms ease-out forwards`,
        transform: "translate(-50%, 0)",
      }}
    >
      +{float.amount} XP
    </div>
  );
}
